import React, { useEffect, useState, useRef } from 'react';
import Stomp from "stompjs";
import {NotificationManager} from 'react-notifications';
import * as conf from "../config/config";

let url =  "wss://"+conf.activeMq01;
const url1 =  "wss://"+conf.activeMq01;
const url2 =  "wss://"+conf.activeMq02;
const user = "WEBSOCKET";
const pass = "w3bs0k3t2024";
let client = Stomp.client(url);
let postOrigin = false;

const MonitoreoMensajeria = ({
    topic,
    mtipo,
    gpsTipo,
    mensaje,
    elementosT,
    elementosN,
    storeFunction,
    updateT,
    update,
    openmodal,
    metodo,
    stor,
    movPatio,
    updateMovPatio
}) => {

  const [mensajeEntrante, setMensajeEntrante] = useState(null);
  const elementosNRef = useRef(elementosN);

  useEffect(() => {
    elementosNRef.current = elementosN;
  }, [elementosN]);

  useEffect(() => {
      if(topic.length){
        console.log("conectar al websocket: ");
        conectar();
      }    
  }, [topic]);

  const conectar = () => {        
    client = Stomp.client(url);
    client.heartbeat = {
        incoming: 20000,
        outgoing: 20000,
    };
    client.debug = () => {};
    client.reconnect_delay = 5000;
    client.connect(
        user,
        pass,
        (frame) => {
          //Conect callback       
          if (topic && topic.length) {
            for (let t of topic) {
              client.subscribe(t, (message) => { 
                //let actualizar= udate;        
                if (message.body.includes("{")) {  
                  //actualizar(message.body); 
                  setMensajeEntrante(JSON.parse(message.body));
                  //console.log("Mensaje recibido en topic: " + t);
                  //console.log(JSON.parse(message.body));
                }              
              });
            }
          }
        },
        (err) => {               
          url = (url === url1) ? url2 : url1;
          //error useCallback
          console.log(err);
          if (typeof err === "string" && err.toUpperCase().includes("LOST CONNECTION")) {
            setTimeout(() => {
              conectar();
            }, 5000);
            //alert(err);
          }        
        }
    );
  }

  useEffect(() => {
    if(mensajeEntrante){
      udate(mensajeEntrante);
    }    
  }, [mensajeEntrante]);

  useEffect(() => {
    if(metodo !== "get"  && stor.updateStatusMensaje_Object && mensaje.data){
        sendMessage(mensaje.data.idPlataforma.id + mensaje.data.corredor.id ,mensaje)
      }
    }, [metodo, mensaje]);

  const udate = (mensaje) => {
    
        
    if(mensaje.vista == "navieraMovimientosMasivo"){
        if(mtipo){
          if(mtipo === mensaje.data.idMovimientoTipo.id){
          }else{ return;}
        }
        let movimientos=  [...elementosNRef.current];
        if (mensaje.accion !== "post"){
          movimientos.map((elemento, index) =>{
            switch (mensaje.accion) {
              case "put":     if(elemento["id"] == mensaje.data.id){ movimientos[index]= mensaje.data } break;
              case "delete":  if(elemento["id"] == mensaje.data.id){ movimientos.splice(index, 1) }     break;
              default:  break;
            }
          });
        }
        if (mensaje.accion === "post" && postOrigin === false){ movimientos.push(mensaje.data); }else{ postOrigin= false; }
        stor.movimientos_naviera_update(movimientos);
        if( update !== "" ){ update(movimientos); }
    } 


    if(mensaje.vista == "navieraMovimientos"){
        if (mensaje.accion === "error"){
          NotificationManager.error(mensaje.mensaje, "Atención", (1000*10));
        }
        if(mtipo){
          if(
            mensaje.data && mensaje.data.idMovimientoTipo
             && mtipo === mensaje.data.idMovimientoTipo.id
          ){
          }else{
            //console.log("mensaje error ---- >>");
            //console.log(mensaje);
            return;
          }
        }
        let movimientos = [...elementosNRef.current];
        if (mensaje.accion !== "post"){
          movimientos.map((elemento, index) =>{
            switch (mensaje.accion) {
              case "put":     if(elemento["id"] == mensaje.data.id){ movimientos[index]= mensaje.data } break;
              case "delete":  if(elemento["id"] == mensaje.data.id){ movimientos.splice(index, 1) }     break;
              default:  break;
            }
          });
        }

        if (mensaje.accion === "post" && postOrigin === false){
          if(gpsTipo != null && mensaje.data.idOperacionEstatus.id == gpsTipo){
             movimientos.push(mensaje.data); 
          }

          if(gpsTipo == undefined || gpsTipo == null || gpsTipo == 0){
             movimientos.push(mensaje.data); 
          }
            
        
        }else{ postOrigin= false; }
            stor.movimientos_naviera_update(movimientos);
        if( update !== "" ){ update(movimientos); }
    }

    if(mensaje.vista == "terrestreMovimientos"){
        // NotificationManager.info(mensaje.mensaje,
        //     mensaje.accion === "put" ?  "Modificación":
        //     mensaje.accion === "post" ? "Nuevo":
        //     mensaje.accion === "delete" ? "Finalizar Movimiento":"Acción",200);
        let movimientos=  elementosT;
        if (mensaje.accion !== "post"){
            if(movimientos){    
              movimientos.map((elemento, index) =>{
               switch (mensaje.accion) {
                 case "put":
                   if(elemento["id"] === mensaje.data.id){
                     movimientos[index]= mensaje.data;
                   }
                   break;
                 case "delete":
                   if(elemento["id"] == mensaje.data.id){
                     movimientos.splice(index, 1) }
                   break;
                 default:  break;
               }
             });
           }
        }
        if (mensaje.accion === "post" && postOrigin === false){ movimientos.push(mensaje.data); }else{ postOrigin= false; }
        if(movimientos){
            //stor.movimientos_terrestres_update([...movimientos]);
            if( updateT !== "" ){ updateT([...movimientos]); }
        }            
    }

    if(mensaje.vista == "movimientosPatio"){
        if(updateMovPatio && mensaje.data){
          let updated = {...movPatio};
          switch (mensaje.accion) {
            case "post":
            case "put":
              updated[mensaje.data.idMovimiento] = mensaje.data;
              break;
            case "delete":
              delete updated[mensaje.data.idMovimiento];
              break;
            default: break;
          }
          updateMovPatio(updated);
        }
    }
  }

  const sendMessage = (topic, msg) => {   
    stor.updateStatusMensaje(false);  
    postOrigin= true;
    /*if(msg.vista == "navieraMovimientosMasivo"){           
        client.send(topic, {}, JSON.stringify(msg));
    }*/
    if(msg.vista == "navieraMovimientos"){           
        client.send(topic, {}, JSON.stringify(msg));
    }     
    if(msg.vista == "terrestreMovimientos"){           
        client.send(topic, {}, JSON.stringify(msg));
    }         
  };

  return (
    <>      
    </>
  )
}

export default MonitoreoMensajeria;
